export default {
  loading: false,
  mgmt_invoices: [],
  mgmt_invoice: {},
  totalCount: 0,
};
